import React from "react";

const NutrientInput = ({
  name,
  percent = false,
  suffix,
  onChange,
  value,
  readOnly = false,
  widgetStyle = false,
  min = "0",
  max,
}) => {
  return (
    <div className={`nutrient-input${percent ? " percent" : ""}`}>
      <input
        name={name}
        type="number"
        inputMode="numeric"
        className="text-input"
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
      />
      {!!suffix && (
        <span
          className={!widgetStyle ? "suffix" : "suffix-widget"}
        >
          {suffix}
        </span>
      )}
    </div>
  );
};

export default NutrientInput;
